import Track from "./track"
import Playlist from "./playlist"

export async function load(attributes) {
  const response = await fetch(attributes["json_path"])
  const body = await response.json()
  return buildPlayable(body)
}

function buildPlayable(response) {
  if (response.type === "audio" || response.type === "video") {
    return new Track(response)
  } else if (response.type === "playlist") {
    return new Playlist({ tracks: response.tracks, name: response.name, path: response.path, user: response.user, picture_url: response.picture_url, picture_url_xlarge: response.picture_url_xlarge })
  }
}
